import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_ORDINARY_FOR_ORDINARY_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation discountOrdinaryForOrdinaryUpdate($input: DiscountOrdinaryInput!) {
		discountOrdinaryUpdate(input: $input) {
			userErrors
		}
	}
`);
